import React from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Lnb from '../../components/Lnb';
import Location from '../../components/Location';

const CounselMain: React.FC = () => {
    return (
        <div id="warp">
            <Header />
            <section id="containers">
                <div className='therapy'>
                    <Lnb />
                    <div id="contents" className='contents'>
                        <h2>제휴심리상담센터</h2>
                        <Location
                            locations={[
                                {title: "토닥토닥마음케어", url: "/column/columnList"}
                            ]}
                            menuName='제휴심리상담센터'
                        />
                        <div className="mobileface psyCenter">
                            <h3 className="green f16">고객님의 마음을 어루만지는 특별한 심리케어 서비스!</h3>
                            <p className="mt15 lh24">편리하게 심리상담을 받으실 수 있도록 스마트한 화상 심리상담과 직접 제휴심리센터에 방문 중 원하시는 방법을 선택하실 수 있어요.</p>
						    <div className="infobox mt40">
                                <div>
                                    <h4>화상 심리상담<span className="br"></span>(고객 실비 부담)</h4>
                                    <p>편리성과 합리적 비용, 상담 내용과 신상 정보를 남기지 않는 상담을 원하시는 고객님께 추천 드려요</p>
                                    <ol>
                                        <li>“헬로마인드케어”<br />App 설치</li>
                                        <li>회원가입</li>
                                        <li>상담분야, <span className="br"></span>심리상담사 선택<br />※상담권 구매 후 이용</li>
                                    </ol>
                                    <div className="appBox">
                                        <span>앱설치하기</span>
                                        <a href="https://play.google.com/store/apps/details?id=com.aimmed.hello&referrer=utm_source%3DBrand_site%26anid%3Dadmob" target="_blank" className="m white">안드로이드</a>
                                        <a href="https://itunes.apple.com/kr/app/%ED%97%AC%EB%A1%9C%EB%A7%88%EC%9D%B8%EB%93%9C%EC%BC%80%EC%96%B4/id1406238166?l=ko&ls=1&mt=8" target="_blank" className="m white">iOS</a>
                                    </div>
                                </div>
							<div className="col2">
								<h4>제휴심리상담센터 <span className="br"></span>직접 내방</h4>
								<ul className="li_common f14">
									<li>제휴심리상담센터 직접 내방 시 우대혜택 제공(최대 30%)</li>
									<li>예약 및 안내는 헬스콜센터로 문의해주세요.</li>
								</ul>
								<ol>
									<li>
										교보헬스콜센터 &amp; 
										<span className="br"></span>오프라인 심리상담센터
										<a href="javascript:void(0)" className="pc">문의/예약 1588-7524</a>
										<a href="tel:1588-7524" className="mobile">문의/예약 1588-7524</a>
										<a href="javascript:void(0)" className="tablet">문의/예약 1588-7524</a>
									</li>
									<li>심리상담센터 방문<br />(고객 실비 부담)</li>
								</ol>
							</div>
							<div>
								<h4>온라인 심리상담</h4>
								<p>전문심리상담사와의 온라인 심리상담</p>
								<a href="https://kyobohealthcare.aimmed.com/util/util_PsyCounsel.asp" className="m white mt10">온라인 심리상담 가기</a>
							</div>
						</div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default CounselMain;